import { flip, shift, offset, size } from '@floating-ui/react-dom';
import { pxToRem } from '../../v2/foundation/spacing/utils.js';

var PADDING = 10;
var defaultFloatingPositionMiddleware = [flip(), shift({
  padding: PADDING
}), offset({
  mainAxis: 2
}), size({
  padding: PADDING,
  apply: function apply(_ref) {
    var availableHeight = _ref.availableHeight,
      availableWidth = _ref.availableWidth,
      elements = _ref.elements;
    Object.assign(elements.floating.style, {
      maxHeight: pxToRem(availableHeight),
      maxWidth: pxToRem(availableWidth)
    });
  }
})];
/**
 * useContextPosition middleware to make the floating element the same
 * size as the target element.
 */
function parentWidth() {
  return size({
    apply: function apply(_ref2) {
      var elements = _ref2.elements,
        rects = _ref2.rects;
      Object.assign(elements.floating.style, {
        minWidth: pxToRem(rects.reference.width),
        maxWidth: pxToRem(rects.reference.width)
      });
    }
  });
}

export { defaultFloatingPositionMiddleware, parentWidth };
